import {storage} from '../../services/config/storage';
const user = storage.fetch.userDetails();

export const initialState = {
    auth: null,
    watchList: {
        company: {},
        industry: {},
        country: {},
        rate: {},
        credit: {},
        currency: {},
        DigitalAssets: {},
    },
    userPortfolio: [],
    user: {},
    userImage: null,
    whatsnew: [],
    emailFreqOptions: [],
    analystReports: [],
    analystData: {
        otherAnalysts: [],
        analystStatus: false,
        bio: '',
        analystId: null,
        analystName: '',
        analystDesignation: '',
        askAnalyst: null,
    },
    uiPageMenu: {
        home: null,
        macro: null,
        industry: null,
        etf: null,
        screener: null,
        corporate: null,
        followAnalysts: null,
        watchlist: null,
        learn: null,
        userPreference: null,
    },
    isFreeUser: user?.role === 'Free User',
    isSilverUser: user?.role === 'Silver User', // Basic
    isGoldUser: user?.role === 'Gold User', // Premium
    isPlatinumUser: user?.role === 'Platinum User', // Pro
    isAdminUser: user?.role === 'Admin', // Admin
    isAnalystUser: user?.role === 'Analyst', // Analyst
    isProductionUser: user?.role === 'Production', //Production
    isSalesUser: user?.role === 'Sales', //Sales
    isPremiumDigitalUser: user?.role === 'Premium Digital', //Premium Digital
    isPremiumPrimeUser: user?.role === 'Premium Prime', //Premium Prime
    activeModal: null,
    helpVideoLink: null,
    showPwdChangePopup: false,
    shareUrls: null,
    shareUrlsTitle: null,
    isHelperRequested: false,
    isFreeShareUrlDisabled: false,
};
